
export function parseUtcOffset(input) {
    if (input == null) return null;

    let raw = String(input).trim().toUpperCase();
    if (raw === 'UTC' || raw === 'GMT' || raw === '0' || raw === '00:00' || raw === '+0' || raw === '-0' || raw === '+00:00' || raw === '-00:00') {
        return 0;
    }
    raw = raw.replace(/^UTC/, '').replace(/^GMT/, '').trim();

    const m = raw.match(/^([+-])\s*(\d{1,2})(?::?(\d{2}))?$/);
    if (!m) return null;

    const sign = m[1] === '+' ? 1 : -1;
    const hh = Number(m[2]);
    const mm = m[3] ? Number(m[3]) : 0;

    if (!Number.isFinite(hh) || !Number.isFinite(mm)) return null;
    if (mm < 0 || mm >= 60) return null;
    if (sign === +1) {
        if (hh > 14) return null;
        if (hh === 14 && mm > 0) return null;
    } else {
        if (hh > 12) return null;
        if (hh === 12 && mm > 0) return null;
    }

    return sign * (hh * 60 + mm);
}

export function getShiftedMs(tsSec, timezoneUtc) {
    const offsetMin = parseUtcOffset(timezoneUtc);
    const tsMs = Number(tsSec) * 1000;
    if (!Number.isFinite(tsMs)) throw new Error('getShiftedMs: tsSec must be a unix timestamp in seconds');
    if (offsetMin === null) return tsMs;
    return tsMs + offsetMin * 60 * 1000;
}
export function buildTzLabel(tzObj) {
    if (!tzObj || typeof tzObj !== 'object') return '';
    const code = tzObj.timezone_code && String(tzObj.timezone_code).trim();
    if (code) return code;

    const off = parseUtcOffset(tzObj.timezone_utc);
    if (off === null) return '';

    const abs = Math.abs(off);
    const hh = String(Math.trunc(abs / 60)).padStart(2, '0');
    const mm = String(abs % 60).padStart(2, '0');
    const sign = off >= 0 ? '+' : '-';
    return `UTC${sign}${hh}${mm === '00' ? '' : ':' + mm}`;
}
export function formatDateDayByUtcOffset(tsSec, timezoneUtc, locale = 'en-US') {
    const ms = getShiftedMs(tsSec, timezoneUtc);
    return new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    }).format(ms);
}
export function formatTimeByUtcOffset(tsSec, timezoneUtc, locale = 'en-US') {
    const ms = getShiftedMs(tsSec, timezoneUtc);
    return new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
    }).format(ms);
}
export function formatDayTimeForEvent(tsSec, tzObj, locale = 'en-US') {
    const timezoneUtc = tzObj?.timezone_utc;
    return {
        day: formatDateDayByUtcOffset(tsSec, timezoneUtc, locale),
        time: formatTimeByUtcOffset(tsSec, timezoneUtc, locale),
        label: buildTzLabel(tzObj),
    };
}
export function formatEventRangeLine(startSec, endSec, tzObj, locale = 'en-US') {
    const s = formatDayTimeForEvent(startSec, tzObj, locale);
    const e = formatDayTimeForEvent(endSec,   tzObj, locale);

    const sameDay = s.day === e.day;
    const label = s.label || e.label || '';

    if (sameDay) {
        return `${s.day} • ${s.time} - ${e.time}${label ? ' ' + label : ''}`;
    }
    return `${s.day} • ${s.time} - ${e.day} • ${e.time}${label ? ' ' + label : ''}`;
}
export function formatEventStartLine(startSec, tzObj, locale = 'en-US') {
    const s = formatDayTimeForEvent(startSec, tzObj, locale);
    return `${s.day} • ${s.time}${s.label ? ' ' + s.label : ''}`;
}




